// extracted by mini-css-extract-plugin
export default {"blockWithHoveredHint":"BlockTooltip_blockWithHoveredHint__m1Qu7","modalContentTitleBlock":"BlockTooltip_modalContentTitleBlock__tZH+L"};